'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var host = exports.host = 'http://exyhw.exyvip.com';


// WEBPACK FOOTER //
// ./src/env.js